import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type CardVariant = 'classic' | 'holo' | 'brutal' | 'neon';
export type StatLayout = 'table' | 'bars' | 'radial';
export type Arena = 'stadium' | 'ring' | 'smoke' | 'pyro';
export type ThemeIntensity = 'balanced' | 'redHeavy' | 'blueHeavy' | 'monochrome';
export type AnimIntensity = 'subtle' | 'cinematic' | 'overTop';

export interface Tweaks {
  cardVariant: CardVariant;
  statLayout: StatLayout;
  arena: Arena;
  themeIntensity: ThemeIntensity;
  animIntensity: AnimIntensity;
  haptics: boolean;
}

interface TweaksStore extends Tweaks {
  set<K extends keyof Tweaks>(key: K, value: Tweaks[K]): void;
}

const DEFAULTS: Tweaks = {
  cardVariant: 'holo',
  statLayout: 'table',
  arena: 'stadium',
  themeIntensity: 'balanced',
  animIntensity: 'cinematic',
  haptics: true,
};

export const useTweaks = create<TweaksStore>()(
  persist(
    (setStore) => ({
      ...DEFAULTS,
      set: (key, value) => setStore({ [key]: value } as Partial<Tweaks>),
    }),
    { name: 'slamfest-tweaks-v1' },
  ),
);
